import { Form, Grid, Panel, Select, SingleColumnLayout, ISelectOption } from '@salecycle/ui-component-library';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import NewUserSidebar from '../../NewUserSidebar';
import { useNewUserDispatch, useNewUserState } from '../../../context/useNewUserContext';
import { updateStepValidityAction } from '../../../actions';
import { getRoleOptions, isAccessLevelSaleCycle } from 'sections/user-management/utils/helpers';
import { Level } from 'sections/user-management/entities';

export interface IProps {
  currentStep: number;
}

/* eslint-disable react-hooks/exhaustive-deps */
export const SetUserRoleStep: React.FC<IProps> = ({ currentStep }: IProps) => {
  const { t } = useTranslation();
  const { validSteps, user, roles } = useNewUserState();
  const dispatch = useNewUserDispatch();
  const roleOptions = getRoleOptions(roles, isAccessLevelSaleCycle(user.selectedAccessLevel?.value as Level));

  React.useEffect(() => {
    updateStepValidityAction(!!user.selectedRole, validSteps, currentStep, dispatch);
  }, [user.selectedRole]);

  const handleRoleChange = (selectedOption: ISelectOption<string>) => {
    const { permissions } = roles.find(role => role.id === selectedOption.value);
    dispatch({
      type: 'SET_SELECTED_ROLE_VALUE',
      payload: { selectedRole: selectedOption, rolePermissions: permissions },
    });
  };

  return (
    <SingleColumnLayout
      paddingLeft={20}
      heading={t('newUser.setUserRoleStep.heading')}
      showSidebar={true}
      sidebar={<NewUserSidebar currentStep={currentStep} />}
      sidebarHeading={t('newUser.sidebar.title')}
    >
      <Grid>
        <Panel variation="clean">
          <Form>
            <Select
              ariaLabel={t('newUser.setUserRoleStep.role.label')}
              label={t('newUser.setUserRoleStep.role.label')}
              inputId="RoleSelect"
              onChange={handleRoleChange}
              options={roleOptions}
              value={user.selectedRole}
              clearable={true}
              isSorted={true}
            />
            {/* The following permission information is temporary until we have a proper design for it */}
            {user.selectedRole && (
              <div>
                <p>{t('newUser.setUserRoleStep.role.permissionsMessage')}</p>
                <ul style={{ paddingLeft: '20px' }}>
                  {user.rolePermissions.map((permission, index) => (
                    <li key={index}>{t(`newUser.setUserRoleStep.role.permissions.${permission}`)}</li>
                  ))}
                </ul>
              </div>
            )}
          </Form>
        </Panel>
      </Grid>
    </SingleColumnLayout>
  );
};
